import { HttpService } from '@/shared/services'
import Vacation from '../models/Vacation'
import CreateVacationInputDto from './interfaces/CreateVacationInputDto'
import List from '@/shared/dtos/List'
import GetDaysOutputDto from './interfaces/GetDaysOutputDto'
import GetDateEndInputDto from './interfaces/GetDateEndInputDto'
import GetDateEndOutputDto from './interfaces/GetDateEndOuputDto'
import AllowPaidVacationDto from './interfaces/AllowPaidVacationDto'

const http = new HttpService()

export const createVacationRequest = async (
  vacationRequest: CreateVacationInputDto
) => {
  const formData = new FormData()
  const { file, ...rest } = vacationRequest

  formData.append('vacation', JSON.stringify(rest))
  formData.append('file', file)

  const response = await http.post<any, string>('/vacations', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response.data
}

export const getVacationsByEmployeeId = async (employeeId: string) => {
  const response = await http.get<List<Vacation[]>>(`/vacations/${employeeId}`)
  return response.data
}

export const getDaysByEmployeeId = async (employeeId: string) => {
  const response = await http.get<GetDaysOutputDto>(
    `/vacations/days/${employeeId}`
  )
  return response.data
}

export const getDateEnd = async (dto: GetDateEndInputDto) => {
  const response = await http.post<GetDateEndInputDto, GetDateEndOutputDto>(
    `/vacations/endDate`,
    dto
  )

  return response.data
}

export const deleteVacationById = async (vacationId: string) => {
  const response = await http.delete<string>(`/vacations/${vacationId}`)

  return response.data
}

export const getVacationReceipt = async (vacationId: string) => {
  const response = await http.post<any, any>(
    `/vacations/receipt/${vacationId}`,
    {},
    {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/pdf',
        Accept: 'application/pdf',
      },
    }
  )
  return response.data
}

export const allowPaidVacations = async (employeeId: string) => {
  const response = await http.get<AllowPaidVacationDto>(
    `/vacations/allowPaidVacations/${employeeId}`
  )
  return response.data
}

export const getVacationBalance = async (employeeId: string) => {
  const response = await http.get<number>(`/vacations/${employeeId}/balance`)
  return response.data
}
